import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from "sweetalert2";
import {ApprovalService} from '../../../service/approval.service';
import {ApprovalPending} from '../../../shared/dto/approval-pending';
import {DispatchSidModel} from '../../../shared/dto/dispatch-sid.model';
import {TokenStorageService} from '../../../shared/service/token-storage.service';

@Component({
  selector: 'app-manual-dispatch',
  templateUrl: './manual-dispatch.component.html',
  styleUrls: ['./manual-dispatch.component.scss']
})
export class ManualDispatchComponent implements OnInit {
  sidNo:string;
  dispatchDto: DispatchSidModel = new DispatchSidModel();
  userName: string;
  isError: boolean = false;
  appRefNo:number;
  type: string;

  constructor(private route: ActivatedRoute,private approvalService: ApprovalService,
              private tokenStorageService: TokenStorageService,private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.sidNo = this.decodeBase64(params.get('sid'));
     });
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('appRefNo'));
    });
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  decodeBase64(code: string): string {
    return atob(code);
  }

  ngOnInit() {
  }

  dispatch() {
    this.dispatchDto.appRefNo = this.appRefNo;
    this.dispatchDto.updatedUser=this.userName;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to dispatch the card?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.dispatch(this.dispatchDto).subscribe(
          (success: string) => {
            this.router.navigate(['/dashboard/dispatch',this.type] );
          },
          (error) => {
            this.isError = true;
          },
        );
      } else {
      }
    });
  }

}
